<template lang="pug">
v-container(fluid='')
  v-card(v-if="employee")
    v-card-title.d-flex.justify-space-between
      span Legajo: {{ employee.userId.name }}
      div
        v-btn.mr-2(color='primary', @click='editFile')
          v-icon(left='') mdi-pencil
          | Editar
        v-btn(text='', @click='$router.back()')
          | Volver
          
    v-card-text
      v-tabs(v-model='activeTab')
        v-tab Datos Personales
        v-tab Información Laboral
        v-tab Asistencia
        v-tab Horarios
        v-tab Uniformes
        v-tab Sanciones

      v-tabs-items(v-model='activeTab')
        // Tab Datos Personales
        v-tab-item
          v-card(flat)
            v-card-text
              h3.mb-4 Información Personal
              v-row
                v-col(cols="12", sm="4")
                  strong DNI:
                  .mt-1 {{ employee.personalInfo.dni || 'No registrado' }}
                v-col(cols="12", sm="4")
                  strong CUIL:
                  .mt-1 {{ employee.personalInfo.cuil || 'No registrado' }}
                v-col(cols="12", sm="4")
                  strong Fecha de Nacimiento:
                  .mt-1 {{ formatDate(employee.personalInfo.birthDate) || 'No registrada' }}
              v-row.mt-4
                v-col(cols="12", sm="6")
                  strong Teléfono:
                  .mt-1 {{ employee.personalInfo.phone || 'No registrado' }}
                v-col(cols="12", sm="6")
                  strong Email:
                  .mt-1 {{ employee.userId.email || 'No registrado' }}
              
              h3.mb-4.mt-6 Dirección
              v-row
                v-col(cols="12", sm="12")
                  strong Domicilio completo:
                  .mt-1 {{ getFullAddress || 'No registrado' }}
              
              h3.mb-4.mt-6 Información Bancaria
              v-row
                v-col(cols="12", sm="4")
                  strong Banco:
                  .mt-1 {{ employee.bankInfo.bank || 'No registrado' }}
                v-col(cols="12", sm="4")
                  strong Tipo de Cuenta:
                  .mt-1 {{ employee.bankInfo.accountType || 'No registrado' }}
                v-col(cols="12", sm="4")
                  strong CBU:
                  .mt-1 {{ employee.bankInfo.cbu || 'No registrado' }}
              v-row.mt-2
                v-col(cols="12", sm="4")
                  strong Alias:
                  .mt-1 {{ employee.bankInfo.alias || 'No registrado' }}
        
        // Tab Información Laboral
        v-tab-item
          v-card(flat)
            v-card-text
              h3.mb-4 Datos Laborales
              v-row
                v-col(cols="12", sm="4")
                  strong Fecha de Ingreso:
                  .mt-1 {{ formatDate(employee.employmentInfo.entryDate) || 'No registrada' }}
                v-col(cols="12", sm="4")
                  strong Antigüedad:
                  .mt-1 {{ getSeniorityText }}
                v-col(cols="12", sm="4")
                  strong Período de Prueba:
                  .mt-1
                    v-chip(:color="getProbationColor")
                      | {{ getProbationText }}
              v-row.mt-4
                v-col(cols="12", sm="4")
                  strong Rol:
                  .mt-1 {{ employee.employmentInfo.roleId ? employee.employmentInfo.roleId.name : 'No asignado' }}
                v-col(cols="12", sm="4")
                  strong Cargo específico:
                  .mt-1 {{ employee.employmentInfo.position || 'No registrado' }}
                v-col(cols="12", sm="4")
                  strong Tipo de Contrato:
                  .mt-1 {{ getContractTypeLabel(employee.employmentInfo.contractType) || 'No registrado' }}
              v-row.mt-4
                v-col(cols="12", sm="4")
                  strong Valor hora:
                  .mt-1 ${{ employee.employmentInfo.hourlyRate || 'Según rol' }}
                v-col(cols="12", sm="4")
                  strong Sueldo Base Mensual:
                  .mt-1 ${{ employee.employmentInfo.baseSalary || '0' }}
              
              h3.mb-4.mt-6 Documentos
              v-row(v-if="employee.documents && employee.documents.length > 0")
                v-col(cols="12", sm="6", md="4", v-for="doc in employee.documents", :key="doc._id")
                  v-card(outlined)
                    v-card-title.py-2
                      | {{ getDocumentTypeLabel(doc.type) }}
                    v-card-text.py-2
                      p.mb-0 {{ doc.name }}
                      small Subido: {{ formatDate(doc.uploadDate) }}
                    v-card-actions
                      v-spacer
                      v-btn(text, color="primary", @click="openDocumentPreview(doc.url)") Ver
              v-row(v-else)
                v-col(cols="12")
                  .text-center No hay documentos registrados
              v-row.mt-6
                v-col(cols="12")
                  v-btn(color="primary", @click="uploadDocumentDialog = true")
                    v-icon(left) mdi-upload
                    | Subir Documento
        
        // Tab Asistencia
        v-tab-item
          v-card(flat)
            v-card-text
              v-row
                v-col(cols="12")
                  attendance-summary(:employee-id="employee && employee.userId._id || ''")
        
        // Tab Horarios
        v-tab-item
          v-card(flat)
            v-card-text
              v-row
                v-col(cols="12")
                  employee-schedule-view(:employee-id="employee && employee.userId && employee.userId._id || ''")
        
        // Tab Uniformes
        v-tab-item
          v-card(flat)
            v-card-text
              v-row
                v-col(cols="12")
                  v-card-title.pa-0.d-flex.justify-space-between
                    span Uniformes y Elementos de Trabajo
                    v-btn(color="primary", @click="uniformDialog = true")
                      v-icon(left) mdi-tshirt-crew
                      | Registrar Entrega
                  v-data-table(
                    :headers="uniformHeaders",
                    :items="uniforms",
                    :loading="loadingUniforms",
                    no-data-text="No hay registros de uniformes",
                    :items-per-page="5"
                  )
                    template(v-slot:item.deliveryDate="{ item }")
                      | {{ formatDate(item.deliveryDate) }}
                    template(v-slot:item.returnDate="{ item }")
                      | {{ formatDate(item.returnDate) || 'No devuelto' }}
                    template(v-slot:item.condition="{ item }")
                      v-chip(:color="getConditionColor(item.condition)")
                        | {{ getConditionLabel(item.condition) }}
        
        // Tab Sanciones
        v-tab-item
          v-card(flat)
            v-card-text
              v-row
                v-col(cols="12")
                  v-card-title.pa-0.d-flex.justify-space-between
                    span Sanciones y Apercibimientos
                    v-btn(color="primary", @click="disciplinaryDialog = true")
                      v-icon(left) mdi-clipboard-text
                      | Registrar
                  v-data-table(
                    :headers="disciplinaryHeaders",
                    :items="disciplinaryRecords",
                    :loading="loadingDisciplinary",
                    no-data-text="No hay registros disciplinarios",
                    :items-per-page="5"
                  )
                    template(v-slot:item.date="{ item }")
                      | {{ formatDate(item.date) }}
                    template(v-slot:item.type="{ item }")
                      v-chip(:color="getDisciplinaryTypeColor(item.type)")
                        | {{ getDisciplinaryTypeLabel(item.type) }}
                    template(v-slot:item.appliedBy="{ item }")
                      | {{ item.appliedBy ? item.appliedBy.name : 'Sistema' }}
  
  // Loading
  v-skeleton-loader(
    v-else-if="loading",
    type="card",
    :loading="loading"
  )
  
  // Error
  v-alert(
    v-else,
    type="error",
    text
  ) No se pudo cargar la información del legajo
  
  // Diálogo para subir documento
  v-dialog(v-model="uploadDocumentDialog", max-width="500")
    v-card
      v-card-title Subir Documento
      v-card-text
        v-form(ref="documentForm", v-model="documentFormValid")
          v-select(
            v-model="newDocument.type",
            :items="documentTypes",
            item-text="text",
            item-value="value",
            label="Tipo de Documento",
            :rules="[v => !!v || 'Seleccione un tipo de documento']",
            required
          )
          v-file-input(
            v-model="newDocument.file",
            label="Archivo",
            :rules="[v => !!v || 'Seleccione un archivo']",
            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx",
            show-size,
            counter,
            required
          )
      v-card-actions
        v-spacer
        v-btn(text, @click="uploadDocumentDialog = false") Cancelar
        v-btn(color="primary", :loading="uploadingDocument", :disabled="!documentFormValid", @click="uploadDocument") Subir
  
  // Diálogo para registrar entrega de uniforme
  v-dialog(v-model="uniformDialog", max-width="500")
    v-card
      v-card-title Registrar Entrega de Uniforme
      v-card-text
        v-form(ref="uniformForm", v-model="uniformFormValid")
          v-text-field(
            v-model="newUniform.itemType",
            label="Tipo de Prenda",
            :rules="[v => !!v || 'Ingrese el tipo de prenda']",
            required
          )
          v-text-field(
            v-model="newUniform.size",
            label="Talle"
          )
          v-select(
            v-model="newUniform.condition",
            :items="conditions",
            item-text="text",
            item-value="value",
            label="Estado",
            required
          )
          v-textarea(
            v-model="newUniform.notes",
            label="Observaciones",
            rows="3"
          )
      v-card-actions
        v-spacer
        v-btn(text, @click="uniformDialog = false") Cancelar
        v-btn(color="primary", :loading="savingUniform", :disabled="!uniformFormValid", @click="saveUniform") Guardar
  
  // Diálogo para registrar sanción o apercibimiento
  v-dialog(v-model="disciplinaryDialog", max-width="500")
    v-card
      v-card-title Registrar Sanción/Apercibimiento
      v-card-text
        v-form(ref="disciplinaryForm", v-model="disciplinaryFormValid")
          v-select(
            v-model="newDisciplinary.type",
            :items="disciplinaryTypes",
            item-text="text",
            item-value="value",
            label="Tipo",
            :rules="[v => !!v || 'Seleccione un tipo']",
            required
          )
          v-menu(
            ref="dateMenu",
            v-model="disciplinaryDateMenu",
            :close-on-content-click="false",
            transition="scale-transition",
            offset-y,
            min-width="auto"
          )
            template(v-slot:activator="{ on, attrs }")
              v-text-field(
                v-model="formattedDisciplinaryDate",
                label="Fecha",
                readonly,
                :rules="[v => !!v || 'Seleccione una fecha']",
                required,
                v-bind="attrs",
                v-on="on"
              )
            v-date-picker(
              v-model="disciplinaryDate",
              @input="disciplinaryDateMenu = false",
              :max="new Date().toISOString().substr(0, 10)"
            )
          v-textarea(
            v-model="newDisciplinary.description",
            label="Descripción",
            :rules="[v => !!v || 'Ingrese una descripción']",
            rows="3",
            required
          )
      v-card-actions
        v-spacer
        v-btn(text, @click="disciplinaryDialog = false") Cancelar
        v-btn(color="primary", :loading="savingDisciplinary", :disabled="!disciplinaryFormValid", @click="saveDisciplinary") Guardar
  
  // Diálogo para previsualizar documento
  v-dialog(v-model="documentPreviewDialog", max-width="800")
    v-card
      v-card-title Previsualizar Documento
      v-card-text
        iframe(:src="documentPreviewUrl", frameborder="0", width="100%", height="600")
      v-card-actions
        v-spacer
        v-btn(text, @click="documentPreviewDialog = false") Cerrar
  
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import AttendanceSummary from '@/components/admin/employee/AttendanceSummary.vue'
import EmployeeScheduleView from '@/components/admin/employee/EmployeeScheduleView.vue'

export default {
  name: 'EmployeeFileDetail',
  
  components: {
    AttendanceSummary,
    EmployeeScheduleView
  },
  
  props: {
    id: {
      type: String,
      required: true
    }
  },
  
  data: () => ({
    loading: true,
    activeTab: 0,
    
    // Uniformes
    loadingUniforms: false,
    uniformHeaders: [
      { text: 'Tipo', value: 'itemType' },
      { text: 'Talle', value: 'size' },
      { text: 'Fecha de Entrega', value: 'deliveryDate' },
      { text: 'Fecha de Devolución', value: 'returnDate' },
      { text: 'Estado', value: 'condition' },
      { text: 'Observaciones', value: 'notes' }
    ],
    
    // Sanciones
    loadingDisciplinary: false,
    disciplinaryHeaders: [
      { text: 'Fecha', value: 'date' },
      { text: 'Tipo', value: 'type' },
      { text: 'Descripción', value: 'description' },
      { text: 'Aplicada por', value: 'appliedBy' }
    ],
    
    // Diálogo de documentos
    uploadDocumentDialog: false,
    documentFormValid: false,
    uploadingDocument: false,
    newDocument: {
      type: '',
      file: null
    },
    documentTypes: [
      { text: 'DNI', value: 'dni' },
      { text: 'CUIL', value: 'cuil' },
      { text: 'Contrato', value: 'contract' },
      { text: 'Certificado Médico', value: 'medicalCertificate' },
      { text: 'Otro', value: 'other' }
    ],
    
    // Diálogo de uniformes
    uniformDialog: false,
    uniformFormValid: false,
    savingUniform: false,
    newUniform: {
      itemType: '',
      size: '',
      condition: 'new',
      notes: ''
    },
    conditions: [
      { text: 'Nuevo', value: 'new' },
      { text: 'Buen estado', value: 'good' },
      { text: 'Dañado', value: 'damaged' },
      { text: 'Perdido', value: 'lost' }
    ],
    
    // Diálogo de sanciones
    disciplinaryDialog: false,
    disciplinaryFormValid: false,
    savingDisciplinary: false,
    disciplinaryDate: new Date().toISOString().substr(0, 10),
    disciplinaryDateMenu: false,
    newDisciplinary: {
      type: '',
      date: new Date(),
      description: ''
    },
    disciplinaryTypes: [
      { text: 'Advertencia', value: 'warning' },
      { text: 'Suspensión', value: 'suspension' },
      { text: 'Sanción', value: 'sanction' },
      { text: 'Reconocimiento', value: 'commendation' }
    ],
    
    // Diálogo de previsualización de documento
    documentPreviewDialog: false,
    documentPreviewUrl: ''
  }),
  
  computed: {
    ...mapState({
      employee: state => state.employeeFiles.current,
      uniforms: state => state.employeeFiles.uniforms,
      disciplinaryRecords: state => state.employeeFiles.disciplinaryRecords
    }),
    
    ...mapGetters({
      getProbationStatus: 'employeeFiles/getProbationStatus',
      getSeniority: 'employeeFiles/getSeniority'
    }),
    
    getFullAddress() {
      if (!this.employee || !this.employee.personalInfo || !this.employee.personalInfo.address) {
        return 'No registrado'
      }
      
      const address = this.employee.personalInfo.address
      let fullAddress = ''
      
      if (address.street) {
        fullAddress += address.street
        if (address.number) {
          fullAddress += ' ' + address.number
        }
      }
      
      if (address.floor || address.apartment) {
        fullAddress += ', '
        if (address.floor) {
          fullAddress += 'Piso ' + address.floor
        }
        if (address.apartment) {
          fullAddress += ' Depto ' + address.apartment
        }
      }
      
      if (address.city) {
        fullAddress += ', ' + address.city
      }
      
      if (address.province) {
        fullAddress += ', ' + address.province
      }
      
      return fullAddress || 'No registrado'
    },
    
    getProbationText() {
      if (!this.employee || !this.employee.employmentInfo || !this.employee.employmentInfo.entryDate) {
        return 'Sin datos'
      }
      
      const status = this.getProbationStatus(this.employee.employmentInfo.entryDate)
      if (status.inProbation) {
        return `En período de prueba (${status.daysLeft} días restantes)`
      } else {
        return 'Confirmado'
      }
    },
    
    getProbationColor() {
      if (!this.employee || !this.employee.employmentInfo || !this.employee.employmentInfo.entryDate) {
        return 'grey'
      }
      
      const status = this.getProbationStatus(this.employee.employmentInfo.entryDate)
      return status.inProbation ? 'info' : 'success'
    },
    
    getSeniorityText() {
      if (!this.employee || !this.employee.employmentInfo || !this.employee.employmentInfo.entryDate) {
        return 'Sin datos'
      }
      
      const seniority = this.getSeniority(this.employee.employmentInfo.entryDate)
      return seniority.text
    },
    
    formattedDisciplinaryDate: {
      get() {
        return this.disciplinaryDate 
          ? format(new Date(this.disciplinaryDate), 'dd/MM/yyyy') 
          : ''
      },
      set(val) {
        // No se usa, solo es para mantener el v-model
      }
    }
  },
  
  created() {
    this.loading = true;

    // Verificar el parámetro tab en la URL para activar la pestaña correspondiente
    if (this.$route.query.tab) {
      switch (this.$route.query.tab) {
        case 'attendance':
          this.activeTab = 2; // Pestaña de Asistencia
          break;
        case 'uniform':
          this.activeTab = 3; // Pestaña de Uniformes
          break;
        case 'disciplinary':
          this.activeTab = 4; // Pestaña de Sanciones
          break;
        case 'schedule':
          this.activeTab = 3; // Pestaña de Horarios
          break;
        default:
          this.activeTab = 0; // Pestaña de Datos Personales por defecto
      }
    }
    
    this.$store.dispatch('employeeFiles/fetchOne', this.id)
      .then(() => {
        this.$store.dispatch('employeeFiles/fetchUniforms', this.id);
        this.$store.dispatch('employeeFiles/fetchDisciplinaryRecords', this.id);
      })
      .catch(error => {
        this.$toast.error(`Error al cargar el legajo: ${error.message}`);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  
  methods: {
    formatDate(date) {
      if (!date) return '-'
      return format(new Date(date), 'dd/MM/yyyy', { locale: es })
    },
    
    getContractTypeLabel(type) {
      const labels = {
        fullTime: 'Tiempo Completo',
        partTime: 'Medio Tiempo',
        temporary: 'Eventual'
      }
      return labels[type] || type
    },
    
    getDocumentTypeLabel(type) {
      const labels = {
        dni: 'DNI',
        cuil: 'CUIL',
        contract: 'Contrato',
        medicalCertificate: 'Certificado Médico',
        other: 'Otro'
      }
      return labels[type] || type
    },
    
    getConditionLabel(condition) {
      const labels = {
        new: 'Nuevo',
        good: 'Buen estado',
        damaged: 'Dañado',
        lost: 'Perdido'
      }
      return labels[condition] || condition
    },
    
    getConditionColor(condition) {
      const colors = {
        new: 'success',
        good: 'primary',
        damaged: 'warning',
        lost: 'error'
      }
      return colors[condition] || 'grey'
    },
    
    getDisciplinaryTypeLabel(type) {
      const labels = {
        warning: 'Advertencia',
        suspension: 'Suspensión',
        sanction: 'Sanción',
        commendation: 'Reconocimiento'
      }
      return labels[type] || type
    },
    
    getDisciplinaryTypeColor(type) {
      const colors = {
        warning: 'warning',
        suspension: 'error',
        sanction: 'error',
        commendation: 'success'
      }
      return colors[type] || 'grey'
    },
    
    editFile() {
      this.$router.push({ 
        name: 'EmployeeFileManager', 
        query: { edit: this.id }
      })
    },
    
    async uploadDocument() {
      if (!this.$refs.documentForm.validate()) return
      
      this.uploadingDocument = true
      
      try {
        await this.$store.dispatch('employeeFiles/uploadDocument', {
          fileId: this.id,
          file: this.newDocument.file,
          type: this.newDocument.type
        })
        
        this.$toast.success('Documento subido correctamente')
        this.uploadDocumentDialog = false
        this.newDocument = {
          type: '',
          file: null
        }
      } catch (error) {
        this.$toast.error(`Error al subir documento: ${error.message}`)
      } finally {
        this.uploadingDocument = false
      }
    },
    
    async saveUniform() {
      if (!this.$refs.uniformForm.validate()) return
      
      this.savingUniform = true
      
      try {
        await this.$store.dispatch('employeeFiles/addUniform', {
          employeeId: this.id,
          uniformData: this.newUniform
        })
        
        this.$toast.success('Uniforme registrado correctamente')
        this.uniformDialog = false
        this.newUniform = {
          itemType: '',
          size: '',
          condition: 'new',
          notes: ''
        }
      } catch (error) {
        this.$toast.error(`Error al registrar uniforme: ${error.message}`)
      } finally {
        this.savingUniform = false
      }
    },
    
    async saveDisciplinary() {
      if (!this.$refs.disciplinaryForm.validate()) return
      
      this.savingDisciplinary = true
      
      try {
        // Actualizar la fecha
        if (this.disciplinaryDate) {
          this.newDisciplinary.date = new Date(this.disciplinaryDate)
        }
        
        await this.$store.dispatch('employeeFiles/addDisciplinaryRecord', {
          employeeId: this.id,
          recordData: this.newDisciplinary
        })
        
        this.$toast.success('Registro disciplinario creado correctamente')
        this.disciplinaryDialog = false
        this.newDisciplinary = {
          type: '',
          date: new Date(),
          description: ''
        }
      } catch (error) {
        this.$toast.error(`Error al crear registro disciplinario: ${error.message}`)
      } finally {
        this.savingDisciplinary = false
      }
    },
    
    openDocumentPreview(url) {
      this.documentPreviewUrl = url
      this.documentPreviewDialog = true
    }
  }
}
</script>

<style scoped>
.v-card__text {
  padding-top: 20px;
}
</style>
